<script>
import ModalCustomerSearch from "@/components/admin/common/modal/CustomerSearch.vue"
import PageGuideDialog from "@/components/admin/fulfillment/guide/PageGuideDialog.vue"
import PartnerApiIntegrationGuide from "@/components/admin/common/guide/PartnerApiIntegrationGuide.vue"

/**
 * Type   : Modal component
 * Title  : 파트너 정보보기
 * Description :
 * 파트너 정보보기 모달
 * 
 * 
 */

export default {
  name: "ModalPartnerInfoForm",
  props:{
    partnerInfo  : Object,
    authLevel    : String,
    mode         : String,
  },
  components: {
    ModalCustomerSearch,
    PageGuideDialog,
    PartnerApiIntegrationGuide
  },
  computed: {
    canEditContract() {
      return this.authLevel === undefined || this.authLevel === null || Number(this.authLevel) >= 90
    },
    canManageApiKeys() {
      return this.mode === 'modify' && Number(this.authLevel || 0) >= 90
    },
    modalTitle() {
      return this.mode === 'create' ? '파트너 등록' : '파트너 정보'
    },
    contractStatus() {
      if (!this.contract_end_date) {
        return { label: '계약일 미입력', color: 'grey-7' }
      }

      const endDate = new Date(`${this.contract_end_date}T23:59:59`)
      if (Number.isNaN(endDate.getTime())) {
        return { label: '계약일 확인 필요', color: 'warning' }
      }

      const today = new Date()
      today.setHours(0, 0, 0, 0)
      if (endDate < today) {
        return { label: '계약 종료', color: 'negative' }
      }

      const daysLeft = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24))
      return daysLeft <= 30
        ? { label: '만료 예정', color: 'orange-8' }
        : { label: '계약중', color: 'positive' }
    },
    contractBadges() {
      const badges = []
      if (Number(this.has_logis_contract) === 1) {
        badges.push({ label: 'LOGIS', color: 'blue-7' })
      }
      if (Number(this.has_fulfillment_contract) === 1) {
        badges.push({ label: 'FULFILLMENT', color: 'teal-7' })
      }
      return badges.length ? badges : [{ label: '계약 없음', color: 'grey-7' }]
    },
    activeApiKeyCount() {
      return this.apiKeyRows.filter(row => Number(row.is_active) === 1).length
    },
    lastApiKeyUsedAt() {
      const usedRows = this.apiKeyRows
        .map(row => row.last_used_at)
        .filter(Boolean)
        .sort()
      return usedRows.length ? usedRows[usedRows.length - 1] : '-'
    },
    hasAnyContract() {
      return Number(this.has_logis_contract) === 1 || Number(this.has_fulfillment_contract) === 1
    },
    bizTypeOptions() {
      return this.$store.getters.getBizTypeCodeList || []
    },
    businessNumberFormatted: {
      get() {
        const val = this.business_number
        if (!val) return ''
        return val
          .replace(/\D/g, '')                       // 숫자만
          .replace(/(\d{3})(\d{2})(\d{0,5})/, '$1-$2-$3') // 포맷팅
          .replace(/(-)$/, '')                      // 끝이 -로 끝나면 제거
      },
      set(val) {
        this.business_number = val.replace(/\D/g, '').slice(0, 10)
      }
    },
    phoneFormatted: {
      get() {
        const val = this.phone.replace(/\D/g, '')
        if (val.startsWith('02')) {
          return val.length > 5
          ? val.replace(/(02)(\d{3,4})(\d+)/, '$1-$2-$3')
          : val.replace(/(02)(\d+)/, '$1-$2')
        } else {
          return val.length > 6
          ? val.replace(/(\d{3})(\d{3,4})(\d+)/, '$1-$2-$3')
          : val.replace(/(\d{3})(\d+)/, '$1-$2')
        }
      },
      set(val) {
        this.phone = val.replace(/\D/g, '').slice(0, 11)
      }
    },
    admin_phoneFormatted: {
      get() {
        const val = this.admin_phone.replace(/\D/g, '')
        if (val.length <= 3) return val
        if (val.length <= 7) return val.replace(/(\d{3})(\d+)/, '$1-$2')
        return val.replace(/(\d{3})(\d{4})(\d+)/, '$1-$2-$3')
      },
      set(val) {
        this.admin_phone = val.replace(/\D/g, '').slice(0, 11)
      }
    },
  },
  emits:[
    'partnerRegistered',
    'partnerUpdated',
    'partnerDeleted',
  ],
  data() {
    return {
      partner_id              : this.partnerInfo?.id || '',
      partner_name            : this.partnerInfo?.partner_name || '',
      business_number         : this.partnerInfo?.business_number || '',
      ceo_name                : this.partnerInfo?.ceo_name || '',
      business_type           : this.partnerInfo?.business_type || '',
      phone                   : this.partnerInfo?.phone || '',
      email                   : this.partnerInfo?.email || '',
      address                 : this.partnerInfo?.address || '',
      logo_url                : this.partnerInfo?.logo_url || '',
      adminId                 : this.partnerInfo?.adminId || '',
      admin_name              : this.partnerInfo?.admin_name || '',
      admin_phone             : this.partnerInfo?.admin_phone || '',
      admin_email             : this.partnerInfo?.admin_email || '',
      item_categories         : this.partnerInfo?.item_categories || '',
      pickup_area             : this.partnerInfo?.pickup_area || '',
      contract_start_date     : this.partnerInfo?.contract_start_date || '',
      contract_end_date       : this.partnerInfo?.contract_end_date || '',
      has_logis_contract      : this.partnerInfo?.has_logis_contract !== undefined ? Number(this.partnerInfo?.has_logis_contract) : 1,
      has_fulfillment_contract: this.partnerInfo?.has_fulfillment_contract !== undefined ? Number(this.partnerInfo?.has_fulfillment_contract) : 0,
      monthly_estimate_volume : this.partnerInfo?.monthly_estimate_volume || '',
      
      activeTab: 'basic',
      modalAdmin : false,
      apiGuideDialog: false,
      apiKeyRows: [],
      apiKeyLoading: false,
      apiKeyIssuing: false,
      apiKeyForm: {
        name: '',
        scopes: 'orders:create, postcode:lookup',
        expiresAt: ''
      },
      issuedApiKey: null,
    }
  },
  methods : {
    parseScopes(value) {
      return String(value || '')
        .split(',')
        .map(scope => scope.trim())
        .filter(Boolean)
    },
    formatScopes(scopes) {
      if (Array.isArray(scopes)) return scopes.join(', ')
      if (!scopes) return '-'
      try {
        const parsed = JSON.parse(scopes)
        return Array.isArray(parsed) ? parsed.join(', ') : String(scopes)
      } catch (_) {
        return String(scopes)
      }
    },
    normalizeScopesForEdit(scopes) {
      if (Array.isArray(scopes)) return scopes.join(', ')
      if (!scopes) return ''
      try {
        const parsed = JSON.parse(scopes)
        return Array.isArray(parsed) ? parsed.join(', ') : String(scopes)
      } catch (_) {
        return String(scopes)
      }
    },
    formatStatus(row) {
      return Number(row.is_active) === 1 ? '활성' : '비활성'
    },
    async loadApiKeys() {
      if (!this.canManageApiKeys || !this.partner_id) return

      this.apiKeyLoading = true
      try {
        const res = await this.$http({
          method: 'POST',
          url: '/api/partner/api-keys/list',
          data: { partnerId: this.partner_id },
          name: '[ Axios / Partner API Key 목록 ]'
        })
        this.apiKeyRows = res.data?.data || []
      } catch (err) {
        this.apiKeyRows = []
        this.$log.debug(err)
        this.$q.notify({
          type: 'negative',
          message: 'API Key 목록 조회에 실패했습니다.',
          position: 'top',
          timeout: 3000,
        })
      } finally {
        this.apiKeyLoading = false
      }
    },
    async issueApiKey() {
      if (!this.apiKeyForm.name.trim()) {
        this.$q.notify({
          type: 'negative',
          message: '키 이름을 입력해주세요.',
          position: 'top',
          timeout: 3000,
        })
        return
      }

      const scopes = this.parseScopes(this.apiKeyForm.scopes)
      if (!scopes.length) {
        this.$q.notify({
          type: 'negative',
          message: '권한 scope를 1개 이상 입력해주세요.',
          position: 'top',
          timeout: 3000,
        })
        return
      }

      this.apiKeyIssuing = true
      try {
        const res = await this.$http({
          method: 'POST',
          url: '/api/partner/api-keys/issue',
          data: {
            partnerId: this.partner_id,
            name: this.apiKeyForm.name.trim(),
            scopes,
            expiresAt: this.apiKeyForm.expiresAt || null
          },
          name: '[ Axios / Partner API Key 발급 ]'
        })
        this.issuedApiKey = res.data?.data || null
        this.apiKeyForm.name = ''
        this.apiKeyForm.expiresAt = ''
        await this.loadApiKeys()
        this.$q.notify({
          type: 'positive',
          message: 'API Key가 발급되었습니다. 원문 키를 지금 복사해 주세요.',
          position: 'top',
          timeout: 3000,
        })
      } catch (err) {
        this.$log.debug(err)
        this.$q.notify({
          type: 'negative',
          message: 'API Key 발급에 실패했습니다.',
          position: 'top',
          timeout: 3000,
        })
      } finally {
        this.apiKeyIssuing = false
      }
    },
    async updateApiKeyScopes(row) {
      if (!row?.id) return
      const currentScopes = this.normalizeScopesForEdit(row.scopes)
      const nextScopesText = window.prompt('API Key 권한 Scope를 입력하세요.', currentScopes)
      if (nextScopesText === null) return

      const scopes = this.parseScopes(nextScopesText)
      if (!scopes.length) {
        this.$q.notify({
          type: 'negative',
          message: '권한 scope를 1개 이상 입력해주세요.',
          position: 'top',
          timeout: 3000,
        })
        return
      }

      try {
        await this.$http({
          method: 'POST',
          url: '/api/partner/api-keys/update-scopes',
          data: {
            partnerId: this.partner_id,
            keyId: row.id,
            scopes
          },
          name: '[ Axios / Partner API Key Scope 수정 ]'
        })
        await this.loadApiKeys()
        this.$q.notify({
          type: 'positive',
          message: 'API Key 권한이 수정되었습니다.',
          position: 'top',
          timeout: 3000,
        })
      } catch (err) {
        this.$log.debug(err)
        this.$q.notify({
          type: 'negative',
          message: 'API Key 권한 수정에 실패했습니다.',
          position: 'top',
          timeout: 3000,
        })
      }
    },
    async deactivateApiKey(row) {
      if (!row?.id) return
      if (!confirm(`${row.name} API Key를 비활성화하시겠습니까?`)) return

      try {
        await this.$http({
          method: 'POST',
          url: '/api/partner/api-keys/deactivate',
          data: {
            partnerId: this.partner_id,
            keyId: row.id
          },
          name: '[ Axios / Partner API Key 비활성화 ]'
        })
        await this.loadApiKeys()
        this.$q.notify({
          type: 'positive',
          message: 'API Key가 비활성화되었습니다.',
          position: 'top',
          timeout: 3000,
        })
      } catch (err) {
        this.$log.debug(err)
        this.$q.notify({
          type: 'negative',
          message: 'API Key 비활성화에 실패했습니다.',
          position: 'top',
          timeout: 3000,
        })
      }
    },
    async copyIssuedApiKey() {
      if (!this.issuedApiKey?.apiKey) return
      try {
        await navigator.clipboard.writeText(this.issuedApiKey.apiKey)
      } catch (_) {
        const textarea = document.createElement('textarea')
        textarea.value = this.issuedApiKey.apiKey
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
      }
      this.$q.notify({
        type: 'positive',
        message: 'API Key를 복사했습니다.',
        position: 'top',
        timeout: 2000,
      })
    },
    async downloadApiGuide() {
      try {
        const res = await this.$http({
          method: 'GET',
          url: '/api/partner/api-guide/download',
          responseType: 'blob',
          name: '[ Axios / Partner API 가이드 다운로드 ]'
        })
        const blob = new Blob([res.data], { type: 'text/markdown;charset=utf-8' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'aone-partner-api-guide.md'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (err) {
        this.$log.debug(err)
        this.$q.notify({
          type: 'negative',
          message: 'API 가이드 문서 다운로드에 실패했습니다.',
          position: 'top',
          timeout: 3000,
        })
      }
    },
    normalizeBusinessType(value = this.business_type) {
      if (!value) return ''

      const options = this.bizTypeOptions
      const matchedByValue = options.find(option => option.value === value)
      if (matchedByValue) {
        return matchedByValue.value
      }

      const matchedByLabel = options.find(option => option.label === value)
      if (matchedByLabel) {
        return matchedByLabel.value
      }

      return value
    },

    /**
     * Title      : 파트너 등록하기
     * Status     : Actived
     * Description : 신규 파트너 등록하기
     */
    async registerPartner() {
      // Validate required fields

      const requiredFields = [
        { label: '파트너명', value: this.partner_name },
        { label: '사업자 번호', value: this.business_number },
        { label: '대표자명', value: this.ceo_name },
        { label: '대표 전화번호', value: this.phone },
        { label: '대표 이메일', value: this.email },
        { label: '사업지 주소', value: this.address },
        { label: '파트너 상품 카테고리', value: this.item_categories },
        { label: '집화지역', value: this.pickup_area },
        { label: '계약시작일', value: this.contract_start_date },
        { label: '계약종료일', value: this.contract_end_date },
      ]
      const missingFields = requiredFields
        .filter(field => !String(field.value || '').trim())
        .map(field => field.label)

      if(missingFields.length > 0){
        this.$q.notify({
          type: 'negative',
          message: `${missingFields.join(', ')} 값을(을) 입력해주세요.`
        });
        return;
      }
      if (!this.hasAnyContract) {
        this.$q.notify({
          type: 'negative',
          message: 'LOGIS 또는 FULFILLMENT 계약 중 최소 1개를 선택해주세요.'
        })
        return
      }

      // Prepare data for submission
      const newPartnerInfo = {
        partner_name            : this.partner_name,
        business_number         : this.business_number,
        ceo_name                : this.ceo_name,
        business_type           : this.normalizeBusinessType(),
        phone                   : this.phone,
        email                   : this.email,
        address                 : this.address,
        logo_url                : this.logo_url,
        adminId                 : this.adminId,
        admin_name              : this.admin_name,
        admin_phone             : this.admin_phone,
        admin_email             : this.admin_email,
        item_categories         : this.item_categories,
        pickup_area             : this.pickup_area,
        contract_start_date     : this.contract_start_date,
        contract_end_date       : this.contract_end_date,
        has_logis_contract      : this.has_logis_contract,
        has_fulfillment_contract: this.has_fulfillment_contract,
        monthly_estimate_volume : this.monthly_estimate_volume,
      };

      try {
        // Send data to API
        let config = {
          method  : "POST",
          data    : newPartnerInfo,
          url     : "/api/partner/registerPartner",
          name    : "[ Axios / registerPartner / 파트너사 등록 ]"
        };

        await this.$http(config)
          .then((res) => {
            this.$q.notify({
              type: 'positive',
              message: '파트너사가 성공적으로 등록되었습니다.',
              position: 'top',
              timeout: 3000,
            });
            this.$emit('partnerRegistered', res.data); // Notify parent component
          })
          .catch((err) => {
            this.$log.debug(err);
            this.$q.notify({
              type: 'negative',
              message: `파트너사 등록에 실패했습니다. 관리자에게 문의해주세요`
            });
          });
      } catch (error) {
        console.error("API 요청 중 오류 발생:", error);
        this.$q.notify({
          type: 'negative',
          message: `파트너사 등록에 실패했습니다. 관리자에게 문의해주세요`
        });
      }
    },

    /** 
     * Title        : 관리자변경
     * Status       : Actived
     * Description  : 관리자 정보를 변경한다
     */
    async changeAdmin(param){
      this.$log.debug("[ Partner info form / changeAdmin / 파트너 정보 변경 ] = ", param)

      // Validate required fields
      if (!param.id) {
        this.$q.notify({
          type: 'negative',
          message: '필수 정보를 입력해주세요.'
        });
        return;
      }

      try {
        // Send data to API

        let payload = {
          id: this.partner_id,
          newAdminId: param.id
        };

        let config = {
          method  : "POST",
          data    : payload,
          url     : "/api/partner/changePartnerAdmin",
          name    : "[ Axios / changePartnerAdmin / 파트너사 관리자 수정 ]"
        }

        await this.$http(config)
          .then((res) => {
            this.partnerList = res.data
            this.$log.debug(`${config.name} 성공 => `, res.data)
            alert(`파트너사 관리자 수정 성공!`)
          })
          .catch((err) => {
            this.$log.debug(err)
            alert(`${config.name} 실패!`)
        })
      } catch (error) {
        console.error("API 요청 중 오류 발생:", error);
        this.$q.notify({
          type: 'negative',
          message: '수정 중 오류가 발생했습니다. 다시 시도해주세요.'
        });
      }
      
    },


    /**
     * Title      : 파트너 정보 수정하기
     * Status     : Actived
     * Description : 파트너 정보 수정하기
     */
    async modifyPartner() {
      // Validate required fields
      if (!this.partner_name || !this.business_number || !this.ceo_name) {
        this.$q.notify({
          type: 'negative',
          message: '필수 정보를 입력해주세요.'
        });
        return;
      }
      if (!this.hasAnyContract) {
        this.$q.notify({
          type: 'negative',
          message: 'LOGIS 또는 FULFILLMENT 계약 중 최소 1개를 선택해주세요.'
        })
        return
      }

      // Prepare data for submission
      const updatedPartnerInfo = {
        id: this.partner_id,
        partner_name: this.partner_name,
        business_number: this.business_number,
        ceo_name: this.ceo_name,
        business_type: this.normalizeBusinessType(),
        phone: this.phone,
        email: this.email,
        address: this.address,
        logo_url: this.logo_url,
        adminId: this.adminId,
        item_categories: this.item_categories,
        pickup_area: this.pickup_area,
        contract_start_date: this.contract_start_date,
        contract_end_date: this.contract_end_date,
        has_logis_contract: this.has_logis_contract,
        has_fulfillment_contract: this.has_fulfillment_contract,
        monthly_estimate_volume: this.monthly_estimate_volume,
      };

      try {
        // Send data to API

        let config = {
          method  : "POST",
          data    : updatedPartnerInfo,
          url     : "/api/partner/modifyPartner",
          name    : "[ Axios / modifyPartner / 파트너사 정보수정 ]"
        }

        await this.$http(config)
          .then((res) => {
            this.partnerList = res.data
            this.$log.debug("[ Axios / PartnerList / 파트너사 목록조회 ] 성공 => ", res.data)
            this.$q.notify({
              type: 'positive',
              message: '파트너 정보가 성공적으로 수정되었습니다.',
              position: 'top',
              timeout: 3000,
            })
            this.$emit('partnerUpdated', this.partner_id)
          })
          .catch((err) => {
            this.$log.debug(err)
            throw Error(`${config.name} 실패!`)
        })
      } catch (error) {
        console.error("API 요청 중 오류 발생:", error);
        this.$q.notify({
          type: 'negative',
          message: '수정 중 오류가 발생했습니다. 다시 시도해주세요.',
          position: 'top',
          timeout: 3000,
        })
      }
    },


    /**
     * Title      : 파트너 삭제하기
     * Status     : Actived
     * Description : 파트너를 삭제한다.
     * @returns {void}
     */
    async deletePartner() {
      
      if (confirm('정말로 이 파트너를 삭제하시겠습니까?')) {
        try {
  
          let payload = {
            id: this.partner_id
          };
  
          // Send delete request to API
          let config = {
            method: "DELETE",
            data: payload,
            url: `/api/partner/delPartner`,
            name: "[ Axios / delPartner / 파트너사 삭제 ]"
          };
  
          await this.$http(config)
            .then(() => {
              alert("파트너가 성공적으로 삭제되었습니다.");
              this.$emit('partnerDeleted', this.partner_id); // Notify parent component
            })
            .catch((err) => {
              this.$log.debug(err);
              alert("삭제 실패! 다시 시도해주세요.");
            });
        } catch (error) {
          console.error("API 요청 중 오류 발생:", error);
          this.$q.notify({
            type: 'negative',
            message: '삭제 중 오류가 발생했습니다. 다시 시도해주세요.'
          });
        }
      }

    }
  },

  mounted(){
    this.$log.debug("파트너 정보보기 모달이 열림", this.partnerInfo)

    this.$getCodeList("BIZTYP").then(() => {
      this.business_type = this.normalizeBusinessType()
    })
    this.loadApiKeys()
  },
}

</script>


<template>

  <q-layout 
    container
    class="lg-width"
    view="lHh lpr lFf">

    <q-header 
      class="bg-primary"
      elevated>
      <q-toolbar>
        <q-toolbar-title>{{ modalTitle }}</q-toolbar-title>
        <q-btn flat v-close-popup round dense icon="close" />
      </q-toolbar>
    </q-header>

    <q-page-container>
      <q-page
        padding>
        <q-card flat bordered class="partner-modal-summary q-mb-md">
          <q-card-section>
            <div class="row items-start justify-between q-col-gutter-md">
              <div class="col-12 col-md">
                <div class="text-h6 text-weight-bold">
                  {{ partner_name || '신규 파트너' }}
                </div>
                <div class="text-caption text-grey-7 q-mt-xs">
                  {{ businessNumberFormatted || '사업자번호 미입력' }} · {{ ceo_name || '대표자명 미입력' }}
                </div>
                <div class="row q-gutter-xs q-mt-sm">
                  <q-badge
                    v-for="badge in contractBadges"
                    :key="badge.label"
                    :color="badge.color"
                    :label="badge.label" />
                  <q-badge
                    :color="contractStatus.color"
                    :label="contractStatus.label" />
                </div>
              </div>
              <div class="col-12 col-md-auto partner-summary-meta">
                <div class="text-caption text-grey-7">담당자</div>
                <div class="text-weight-medium">{{ admin_name || '-' }}</div>
                <div
                  v-if="canManageApiKeys"
                  class="q-mt-sm">
                  <div class="text-caption text-grey-7">API Key</div>
                  <div class="text-weight-medium">
                    활성 {{ activeApiKeyCount }}개 · 마지막 사용 {{ lastApiKeyUsedAt }}
                  </div>
                </div>
              </div>
            </div>
          </q-card-section>
        </q-card>

        <q-tabs
          v-model="activeTab"
          dense
          align="left"
          active-color="primary"
          indicator-color="primary"
          class="partner-modal-tabs q-mb-md">
          <q-tab name="basic" icon="badge" label="기본정보" />
          <q-tab name="contract" icon="handshake" label="계약정보" />
          <q-tab name="admin" icon="manage_accounts" label="담당자" />
          <q-tab
            v-if="canManageApiKeys"
            name="api"
            icon="vpn_key"
            label="API 연동" />
          <q-tab
            v-if="mode === 'modify' && Number(authLevel) >= 90"
            name="danger"
            icon="warning"
            label="위험 작업" />
        </q-tabs>

        <q-tab-panels
          v-model="activeTab"
          animated
          class="partner-modal-panels">
          <q-tab-panel name="basic">
        
        <div class="q-pa-md">
          <div class="form-column-wrap">
            <q-input 
              v-model="partner_name"
              label-slot
              lazy-rules
              ref="partnerNameRef"
              :rules="[val => !!val || '* 표시 항목은 필수 입력입니다.']">
              <template #label>
                <span :class="['custom-label', { required: !partner_name }]">
                  파트너명 *
                </span>
              </template>
            </q-input>

            <q-input 
              v-model="businessNumberFormatted"
              label-slot
              lazy-rules
              :rules="[val => !!val || '* 표시 항목은 필수 입력입니다.']"
              ref="businessNumberRef"
              maxlength="12" >
              <template #label>
                <span :class="['custom-label', { required: !businessNumberFormatted }]">
                  사업자 번호 *
                </span>
              </template>
            </q-input>

            <q-select 
              v-model="business_type"
              ref="businessTypeRef"
              :options="this.$store.getters.getBizTypeCodeList"
              behavior="menu"
              label="비지니스 타입"
              emit-value
              map-options
              label-slot
              lazy-rules
              :rules="[val => !!val || '* 표시 항목은 필수 입력입니다.']">
              <template #label>
                <span :class="['custom-label', { required: !business_type }]">
                  비지니스 타입 *
                </span>
              </template>
            </q-select>
          </div>
        </div>
          
        <div class="q-pa-md">
          <div class="form-column-wrap">
            
            <q-input 
              v-model="ceo_name"
              label-slot
              lazy-rules
              :rules="[val => !!val || '* 표시 항목은 필수 입력입니다.']"
              ref="ceoNameRef"
              maxlength="50"
              @blur="this.$validKor(ceo_name)" >
              <template #label>
                <span :class="['custom-label', { required: !ceo_name }]">
                  CEO 명 *
                </span>
              </template>
            </q-input>
            
            <q-input 
              v-model="phoneFormatted"
              ref="phoneFormattedRef"
              maxlength="12"
              label-slot
              lazy-rules
              :rules="[val => !!val || '* 표시 항목은 필수 입력입니다.']"
              @blur="this.$validMobile(phone)">
              <template #label>
                <span :class="['custom-label', { required: !phoneFormatted }]">
                  대표 전화번호 *
                </span>
              </template>
            </q-input>

            <q-input 
              v-model="email"
              ref="emailRef"
              @blur="this.$validEmail(email)"
              label-slot
              lazy-rules
              :rules="[val => !!val || '* 표시 항목은 필수 입력입니다.']">
              <template #label>
                <span :class="['custom-label', { required: !email }]">
                  대표 이메일 *
                </span>
              </template>
            </q-input>
          </div>
        </div>

        <div class="q-pa-md">
          <div class="form-column-wrap">

            <q-input 
              v-model="address"
              ref="addressRef"
              maxlength="400"
              label-slot
              lazy-rules
              :rules="[val => !!val || '* 표시 항목은 필수 입력입니다.']">
              <template #label>
                <span :class="['custom-label', { required: !address }]">
                  사업지 주소 *
                </span>
              </template>
            </q-input>
          </div>
        </div>
        
        <div class="q-pa-md">
          <div class="form-column-wrap">
        
            <q-input 
              v-model="item_categories"
              ref="itemCategoriesRef"
              label="파트너 상품 카테고리"
              label-slot
              lazy-rules
              :rules="[val => !!val || '* 표시 항목은 필수 입력입니다.']">
              <template #label>
                <span :class="['custom-label', { required: !item_categories }]">
                  파트너 상품 카테고리 *
                </span>
              </template>
            </q-input>
            
            <q-input 
              v-model="pickup_area"
              ref="pickupAreaRef"
              label="집화지역"
              label-slot
              lazy-rules
              :rules="[val => !!val || '* 표시 항목은 필수 입력입니다.']">
              <template #label>
                <span :class="['custom-label', { required: !pickup_area }]">
                  집화지역 *
                </span>
              </template>
            </q-input>

          </div>
        </div>

          </q-tab-panel>

          <q-tab-panel name="contract">
        <div class="q-pa-md">
          <div class="form-column-wrap">
            <q-checkbox
              v-model="has_logis_contract"
              :true-value="1"
              :false-value="0"
              :disable="!canEditContract"
              label="LOGIS 계약" />
            <q-checkbox
              v-model="has_fulfillment_contract"
              :true-value="1"
              :false-value="0"
              :disable="!canEditContract"
              label="FULFILLMENT 계약" />
          </div>
          <div
            v-if="!hasAnyContract"
            class="text-negative text-caption q-mt-sm">
            최소 1개 계약(LOGIS 또는 FULFILLMENT)은 필수입니다.
          </div>
        </div>
        <div class="q-pa-md">
          <div class="form-column-wrap">

            <q-input
              v-model="contract_start_date"
              ref="contractStartDateRef"
              label="계약시작일"
              :disable="Number(authLevel) <= 80 ? true : false"
              label-slot
              lazy-rules
              :rules="[val => !!val || '* 표시 항목은 필수 입력입니다.']">
              <template #label>
                <span :class="['custom-label', { required: !contract_start_date }]">
                  계약시작일 *
                </span>
              </template>
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer" @click="$refs.startDatePicker.show()" />
              </template>
              <q-popup-proxy ref="startDatePicker" transition-show="scale" transition-hide="scale">
                <q-date 
                  v-model="contract_start_date" 
                  mask="YYYY-MM-DD" 
                  format24h
                  @input="$refs.startDatePicker.hide()" />
              </q-popup-proxy>
            </q-input>

            <q-input
              v-model="contract_end_date"
              ref="contractEndDateRef"
              label="계약종료일"
              :disable="Number(authLevel) <= 80 ? true : false"
              label-slot
              lazy-rules
              :rules="[val => !!val || '* 표시 항목은 필수 입력입니다.']">
              <template #label>
                <span :class="['custom-label', { required: !contract_end_date }]">
                  계약종료일 *
                </span>
              </template>
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer" @click="$refs.endDatePicker.show()" />
              </template>
              <q-popup-proxy ref="endDatePicker" transition-show="scale" transition-hide="scale">
                <q-date 
                  v-model="contract_end_date" 
                  mask="YYYY-MM-DD" 
                  format24h
                  @input="$refs.endDatePicker.hide()" />
              </q-popup-proxy>
            </q-input>

          </div>
        </div>



          </q-tab-panel>

          <q-tab-panel name="admin">
        <!-- 관리자 정보 -->
        <h5 class="q-my-lg">
          관리자정보
          <q-btn
            v-if="Number(authLevel) <= 80 ? false : true"
            class="q-ml-md"
            color="secondary"
            icon="edit"
            size="sm"
            label="관리자정보수정"
            @click="modalAdmin = true" />
        </h5>

        <div class="q-pa-md">
          <div class="form-column-wrap">

            <q-input 
              v-model="admin_name"
              maxlength="50"
              label="관리자명"
              readonly />

            <q-input 
              v-model="admin_phoneFormatted"
              label="관리자 전화번호"
              readonly />

            <q-input 
              v-model="admin_email"
              label="관리자 이메일" 
              readonly />

          </div>
        </div>

          </q-tab-panel>

          <q-tab-panel
            v-if="canManageApiKeys"
            name="api">
        <div
          v-if="canManageApiKeys"
          class="q-pa-md">
          <q-card flat bordered class="api-key-card">
            <q-card-section>
              <div class="row items-start justify-between q-col-gutter-md">
                <div class="col-12 col-md">
                  <div class="row items-center no-wrap">
                    <div class="text-h6">API 연동</div>
                    <q-btn
                      flat
                      round
                      dense
                      size="sm"
                      color="primary"
                      icon="help_outline"
                      class="q-ml-xs"
                      aria-label="API 연동 사용 가이드"
                      @click="apiGuideDialog = true">
                      <q-tooltip>API 연동 사용 가이드</q-tooltip>
                    </q-btn>
                  </div>
                  <div class="text-caption text-grey-7">
                    외부 파트너 시스템이 AONE API를 호출할 때 사용하는 API Key를 관리합니다.
                    원문 키는 발급 직후 한 번만 확인할 수 있습니다.
                  </div>
                </div>
                <div class="col-12 col-md-auto">
                  <q-btn
                    flat
                    dense
                    color="primary"
                    icon="download"
                    label="문서 다운로드"
                    class="q-mr-sm"
                    @click="downloadApiGuide" />
                  <q-btn
                    flat
                    dense
                    color="primary"
                    icon="refresh"
                    label="새로고침"
                    :loading="apiKeyLoading"
                    @click="loadApiKeys" />
                </div>
              </div>
            </q-card-section>

            <q-separator />

            <q-card-section>
              <div class="row q-col-gutter-md items-end">
                <div class="col-12 col-md-4">
                  <q-input
                    v-model="apiKeyForm.name"
                    label="키 이름"
                    placeholder="예: partner-order-prod" />
                </div>
                <div class="col-12 col-md-4">
                  <q-input
                    v-model="apiKeyForm.scopes"
                    label="권한 Scope"
                    placeholder="orders:create, postcode:lookup" />
                </div>
                <div class="col-12 col-md-3">
                  <q-input
                    v-model="apiKeyForm.expiresAt"
                    label="만료일"
                    placeholder="선택">
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer" @click="$refs.apiKeyExpiresPicker.show()" />
                    </template>
                    <q-popup-proxy ref="apiKeyExpiresPicker" transition-show="scale" transition-hide="scale">
                      <q-date
                        v-model="apiKeyForm.expiresAt"
                        mask="YYYY-MM-DD"
                        @update:model-value="$refs.apiKeyExpiresPicker.hide()" />
                    </q-popup-proxy>
                  </q-input>
                </div>
                <div class="col-12 col-md-1">
                  <q-btn
                    color="primary"
                    class="full-width"
                    label="발급"
                    :loading="apiKeyIssuing"
                    @click="issueApiKey" />
                </div>
              </div>

              <q-banner
                v-if="issuedApiKey?.apiKey"
                rounded
                class="q-mt-md issued-key-banner">
                <template #avatar>
                  <q-icon name="vpn_key" color="orange-8" />
                </template>
                <div class="text-weight-bold q-mb-xs">발급된 API Key</div>
                <div class="issued-key-value">{{ issuedApiKey.apiKey }}</div>
                <div class="text-caption q-mt-sm">
                  이 키는 다시 조회할 수 없습니다. 지금 복사해 파트너 담당자에게 안전한 경로로 전달하세요.
                </div>
                <template #action>
                  <q-btn
                    flat
                    color="primary"
                    label="복사"
                    @click="copyIssuedApiKey" />
                </template>
              </q-banner>
            </q-card-section>

            <q-card-section>
              <q-table
                flat
                dense
                :loading="apiKeyLoading"
                :rows="apiKeyRows"
                :rows-per-page-options="[5, 10, 20]"
                row-key="id"
                no-data-label="발급된 API Key가 없습니다."
                :columns="[
                  { name: 'name', label: '키 이름', field: 'name', align: 'left' },
                  { name: 'key_prefix', label: 'Prefix', field: 'key_prefix', align: 'left' },
                  { name: 'scopes', label: '권한', field: row => formatScopes(row.scopes), align: 'left' },
                  { name: 'status', label: '상태', field: row => formatStatus(row), align: 'center' },
                  { name: 'expires_at', label: '만료일', field: row => row.expires_at || '-', align: 'center' },
                  { name: 'last_used_at', label: '마지막 사용', field: row => row.last_used_at || '-', align: 'center' },
                  { name: 'created_at', label: '생성일', field: 'created_at', align: 'center' },
                  { name: 'action', label: '관리', field: 'action', align: 'center' },
                ]">
                <template #body-cell-status="props">
                  <q-td :props="props">
                    <q-badge
                      :color="Number(props.row.is_active) === 1 ? 'positive' : 'grey-6'"
                      :label="formatStatus(props.row)" />
                  </q-td>
                </template>
                <template #body-cell-action="props">
                  <q-td :props="props">
                    <q-btn
                      flat
                      dense
                      color="primary"
                      label="권한수정"
                      :disable="Number(props.row.is_active) !== 1"
                      @click="updateApiKeyScopes(props.row)" />
                    <q-btn
                      flat
                      dense
                      color="negative"
                      label="비활성화"
                      :disable="Number(props.row.is_active) !== 1"
                      @click="deactivateApiKey(props.row)" />
                  </q-td>
                </template>
              </q-table>
            </q-card-section>
          </q-card>
        </div>

          </q-tab-panel>

          <q-tab-panel
            v-if="mode === 'modify' && Number(authLevel) >= 90"
            name="danger">
            <q-card flat bordered class="danger-zone-card">
              <q-card-section>
                <div class="row items-start justify-between q-col-gutter-md">
                  <div class="col-12 col-md">
                    <div class="text-h6 text-negative">위험 작업</div>
                    <div class="text-caption text-grey-7 q-mt-xs">
                      파트너 삭제는 해당 파트너 정보를 더 이상 조회하거나 수정할 수 없게 만듭니다.
                      운영 데이터와 연결된 파트너라면 삭제 전에 주문, 상품, API Key 관계를 먼저 확인해야 합니다.
                    </div>
                  </div>
                  <div class="col-12 col-md-auto">
                    <q-btn
                      outline
                      color="negative"
                      icon="delete"
                      label="파트너 삭제"
                      @click="deletePartner" />
                  </div>
                </div>
              </q-card-section>
            </q-card>
          </q-tab-panel>
        </q-tab-panels>

      </q-page>
    </q-page-container>

    <q-footer 
      class="bg-white text-black">
      <q-toolbar
        class="no-gutter">

        <q-btn
          v-if="mode === 'modify'"
          label="수정"
          class="btn full-width"
          size="lg"
          color="secondary"
          @click="modifyPartner">
        </q-btn>

        <q-btn
          v-if="mode === 'create'"
          label="등록"
          class="btn full-width"
          size="lg"
          color="primary"
          @click="registerPartner">
        </q-btn>
      </q-toolbar>
    </q-footer>
  </q-layout>

  <!-- 파트너사 관리자 모달 -->
   <teleport to="body">
		<q-dialog
			v-model="modalAdmin"
			persistent>
      <ModalCustomerSearch
        @change-customer="changeAdmin"
        @close-modal-search="()=> {modalAdmin = false}" />
    </q-dialog>
	</teleport>

  <PageGuideDialog
    v-model="apiGuideDialog"
    title="API 연동 사용 가이드"
    description="파트너 외부 API Key 발급과 전달 기준을 확인합니다.">
    <PartnerApiIntegrationGuide />
  </PageGuideDialog>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h5 {
  margin-block-end: 0.5rem;
}

.btn {
  border-radius: 0px;
}
.no-gutter {
  padding : 0px;
}

.lg-width {
  width : 70vw;
  max-width: 1024px;
}

@media (min-width: 320px){
  .lg-width {
      width : 90vw;
      max-width: inherit;
  }
}

@media (min-width: 600px){
  .lg-width {
      width : 90vw;
      max-width: inherit;
  }
}

@media (min-width: 1024px){
  .lg-width {
      width : 70vw;
      max-width: 1024px;
  }
}

.form-column-wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  gap: 30px;

  .q-field {
    flex: 1;
    flex-basis: 150px;
    // min-width: 150px;
  }

  .mobile-country {
    flex-basis: 120px;
    min-width: 110px;
    max-width: 120px;
  }
}

.custom-label.required {
  color: #e53935; /* 붉은색 */
}
.custom-label {
  // color: #555; /* 기본 라벨 색상 */
  color: #e53935; /* 붉은색 */
  font-weight:700;
}

.partner-modal-summary {
  border: 1px solid #e0e6ef;
  border-radius: 14px;
  background: linear-gradient(135deg, #ffffff 0%, #f7fbff 100%);
}

.partner-summary-meta {
  min-width: 220px;
  padding: 12px;
  border-radius: 12px;
  background: #f4f7fb;
}

.partner-modal-tabs {
  margin-top: 16px;
  border: 1px solid #e0e6ef;
  border-radius: 12px;
  background: #fff;
}

.partner-modal-panels {
  border: 1px solid #e0e6ef;
  border-radius: 12px;
  background: #fff;
}

.danger-zone-card {
  border: 1px solid #f3b5b5;
  border-radius: 12px;
  background: #fff8f8;
}

.api-key-card {
  border: 1px solid #e0e6ef;
  border-radius: 12px;
}

.issued-key-banner {
  background: #fff8e1;
  border: 1px solid #ffe0a3;
}

.issued-key-value {
  word-break: break-all;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff;
  border: 1px dashed #f0a500;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}
</style>
